// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3d4a6ec2","952":"7e16be05"}[chunkId] + ".chunk.js";
};